import { Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MaintenanceStateService } from '../../service/maintenance-state.service';

/** Plan 14c T2: API bakimdayken ust bant. Kirmizi degil; yayinlanmis kartlarin surdugunu soyler. */
@Component({
    selector: 'app-maintenance-banner',
    standalone: true,
    imports: [TranslateModule],
    template: `
        @if (state.active()) {
            <div class="maintenance-banner" role="status" data-testid="maintenance-banner">
                <i class="pi pi-wrench"></i>
                <span>{{ 'COMMON.MAINTENANCE.BANNER' | translate }}</span>
            </div>
        }
    `,
    styles: [`
        .maintenance-banner { display: flex; gap: .5rem; align-items: center; padding: .75rem 1rem;
            background: var(--p-blue-50); color: var(--p-blue-800); border-bottom: 1px solid var(--p-blue-200); }
    `]
})
export class MaintenanceBannerComponent {
    readonly state = inject(MaintenanceStateService);
}
